import { render } from "./PostEditor.vue?vue&type=template&id=9e63358a&scoped=true"
import script from "./PostEditor.vue?vue&type=script&lang=js"
export * from "./PostEditor.vue?vue&type=script&lang=js"

import "./PostEditor.vue?vue&type=style&index=0&id=9e63358a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e63358a"]])

export default __exports__